<app-i18n-dictionary xmlns="http://www.w3.org/1999/html">
    <span [attr.transid]="titleTextId" i18n="@@categories-page_title">Home<br/>of B2B</span>
    <span [attr.transId]="siteTitleTextId" i18n="@@categories-page_site-title">Welcome to Hering Berlin</span>
    <span [attr.transId]="landingDescriptionId" i18n="@@categories-page_site-title">In just a few steps you can arrange the right selection for you or your customers from the large Hering Berlin collection. Under downloads you will find all documents such as price lists, brochures and images as well as logos & CI assets.</span>
    <span [attr.transid]="shopButtonId" i18n="@@categories-page_shop-button">Shop Catalog</span>
    <span [attr.transid]="titleNewsletterId" i18n="@@categories-page_title-newsletter">The Newsletter</span>
    <span [attr.transid]="descriptionNewsletterId" i18n="@@categories-page_description-newsletter">Sign up to our newsletter to learn more about whats happening with Hering Berlin. News, special events and so much more to explore!</span>
</app-i18n-dictionary>

<div class="container">
    <app-spinner-page *ngIf="categoryAttribute == null"></app-spinner-page>
    <div *ngIf="categoryAttribute != null">

        <div class="teaser mat-display-4">
            <div class="scroll-arrow scroll-arrow-link">
            </div>

            <div class="headline">
                <div class="headline-title" i18n="@@categories-page_title">
                    Home<br/>of B2B
                </div>
                <div class="headline-description" i18n="@@categories-page_landing-description">
                    In just a few steps you can arrange the right selection for you or
                    your customers from the large Hering Berlin collection. Under downloads you will find all documents
                    such as price lists, brochures and images as well as logos & CI assets.
                </div>
            </div>

            <div class="headline-buttons" fxLayout="column" fxLayoutGap="20px">
                <button class="shop-button" i18n="@@categories-page_shop-button" routerLink="/products">Shop Catalog
                </button>
                <button class="shop-button" routerLink="/download">Press &
                    Downloads
                </button>
            </div>
        </div>

        <div class="cms-page-container">
            <app-cms-page></app-cms-page>
        </div>

        <div class="row">
            <div class="col newsletter center-items">
                <div class="newsletter-box">
                    <div class="newsletter-title" i18n="@@categories-page_title-newsletter">THE NEWSLETTER</div>
                    <div i18n="@@categories-page_description-newsletter">Sign up to our newsletter to learn more about
                        what's happening with Hering Berlin.
                        News, special events and so much more to explore!
                    </div>
                </div>
            </div>
            <div class="col" fxLayout="row" fxLayoutAlign="center center">
                <form class="newsletter-form" [formGroup]="form" (ngSubmit)="submit()">
                    <mat-form-field>
                        <input appIosAutoFillFix type="email" matInput formControlName="email" placeholder="E-Mail"/>
                        <button matSuffix mat-button>→</button>
                    </mat-form-field>
                </form>
            </div>
        </div>
    </div>
</div>
